import {StoppageInfo} from '@domain/stoppages'
import React, {createContext, useContext, useMemo} from 'react'

export interface StoppageNavigationContextValue {
  navigateToAnalysis: (stoppage: StoppageInfo) => Promise<void>
  navigateToCreateAnalysis: (stoppage: StoppageInfo) => Promise<void>
}

const StoppageNavigationContext = createContext<StoppageNavigationContextValue | undefined>(
  undefined
)

export const useStoppageNavigation = (): StoppageNavigationContextValue => {
  const context = useContext(StoppageNavigationContext)
  if (!context) {
    throw new Error('useStoppageNavigation must be used within a StoppageNavigationProvider')
  }
  return context
}

interface StoppageNavigationProviderProps {
  children: React.ReactNode
  navigateToAnalysis: (stoppage: StoppageInfo) => Promise<void>
  navigateToCreateAnalysis: (stoppage: StoppageInfo) => Promise<void>
}

export const StoppageNavigationProvider: React.FC<StoppageNavigationProviderProps> = ({
  children,
  navigateToAnalysis,
  navigateToCreateAnalysis
}) => {
  const value = useMemo(
    () => ({
      navigateToAnalysis,
      navigateToCreateAnalysis
    }),
    [navigateToAnalysis, navigateToCreateAnalysis]
  )

  return (
    <StoppageNavigationContext.Provider value={value}>
      {children}
    </StoppageNavigationContext.Provider>
  )
}
